import { HelperFunctions } from 'bowman-commons';
import { ImportType } from './import-type.enum';
import { ExternalAuthenticationGroupMapping } from 'src/app/security/model/external-authentication-group-mapping';

export class ExportDto {
    name: string;
    jsonContent: any;
    constructor(content: any, importType: ImportType) {
        let exportObjectName: string;
        switch (importType) {
            case ImportType.DASHBOARD:
                content.id = HelperFunctions.uuid();
                content.widgets.forEach(widget => widget._id = HelperFunctions.uuid());
                exportObjectName = content.name;
                break;
            case ImportType.USER:
                exportObjectName = content.name;
                break;
            case ImportType.GROUP:
                exportObjectName = content.name;
                break;
            case ImportType.ACCESS_CONTROL_SET:
                exportObjectName = content.name;
                break;
            case ImportType.SEARCH_RULE:
                exportObjectName = content.name;
                break;
            case ImportType.MASKING_RULE:
                exportObjectName = content.name;
                break;
            case ImportType.SEARCH_RULE:
                exportObjectName = content.name;
                break;
            case ImportType.LDAP_CONFIGURATION:
                exportObjectName = "ldap-configuration";
                break;
            case ImportType.RADIUS_CONFIGURATION:
                exportObjectName = "radius-configuration";
                break;

            case ImportType.EVENT_EXTRACTOR_CONFIGURATION:
                exportObjectName = content.name;
                break;
            case ImportType.EVENT_EXTRACTOR_GROUP:
                exportObjectName = content.name;
                break;
            case ImportType.EVENT_MODELER_CONFIGURATION:
                exportObjectName = content.name;
                break;
            case ImportType.EXTERNAL_AUTHENTICATION_GROUP_MAPPING:
                let parts: Array<string> = [];
                if ((content as ExternalAuthenticationGroupMapping).groups && (content as ExternalAuthenticationGroupMapping).groups.length > 0) {
                    (content as ExternalAuthenticationGroupMapping).groups.forEach(g => {
                        parts.push(g.name.replace(/ /g, '_').trim().toLocaleLowerCase() + '_');
                    });
                }
                if (parts.length > 0) {
                    exportObjectName = (content as ExternalAuthenticationGroupMapping).externalAuthenticationGroupName + '_' + parts.join('-');
                } else {
                    exportObjectName = (content as ExternalAuthenticationGroupMapping).externalAuthenticationGroupName;
                }
                break;
            case <any>ImportType.TYPE_MAPPING:
                exportObjectName = content.name;
                break;
            case <any>ImportType.DICTIONARY_DEFINITION:
                exportObjectName = content.name;
                break;
        }
        this.name = exportObjectName.replace(/ /g, '_').trim().toLocaleLowerCase();
        this.jsonContent = JSON.stringify(content);
    }

}

